import { jsx, jsxs } from "@emotion/react/jsx-runtime";
import { CircularProgress as CircularProgress$1 } from "@mui/material";
import { containerStyles, labelStyles } from "./CircularProgress.styles.js";
const CircularProgress = ({
  size = 16,
  thickness = 2.5,
  ...props
}) => {
  return /* @__PURE__ */ jsx(CircularProgress$1, { size, thickness, ...props });
};
const CircularProgressWithLabel = ({
  children,
  size = 64,
  ...props
}) => {
  return /* @__PURE__ */ jsxs("div", { css: () => containerStyles(size), children: [
    /* @__PURE__ */ jsx(CircularProgress, { variant: "determinate", size, ...props }),
    /* @__PURE__ */ jsx("div", { css: labelStyles, children })
  ] });
};
export {
  CircularProgress,
  CircularProgressWithLabel
};
//# sourceMappingURL=CircularProgress.js.map
